
import { mapState, mapMutations } from "vuex";
import { common, commonApi } from "@/common/index";
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

export default {
components: { XDialog, Icon },
data() {
return {
list: [],
};
},
computed: {
...mapState({
/*首页弹框 */
homeFloatTopShow: (state) => state.homeFloatTopShow,
homeFloatTopShow2: (state) => state.homeFloatTopShow2,
homeFloatTopShow3: (state) => state.homeFloatTopShow3,
homeFloatTopShow4: (state) => state.homeFloatTopShow4,
homeFloatTopShow5: (state) => state.homeFloatTopShow5,
}),
},
created() {
this._initPage();
},
methods: {
...mapMutations([
"setHomeFloatTop",
"setHomeFloatTop2",
"setHomeFloatTop3",
"setHomeFloatTop4",
"setHomeFloatTop5",
]),
_initPage() {

if (this.homeFloatTopShow) {
commonApi.HOMEBEFORE.getImgGroup("h5HomeNewDialog").then((data) => {
this.list = data;
this.setHomeFloatTop(this.list.length > 0);
});
}
},


handleImg(currentUrl) {
if (currentUrl.length > 0) {
if (currentUrl.indexOf("http") !== -1) {
window.open(currentUrl);
} else if (currentUrl.indexOf("html") !== -1) {
window.open(currentUrl);
} else {
this.$router.push({ path: currentUrl.replace("#", "") });
}
}
},

_close(index) {

if (index == "0") {
this.setHomeFloatTop(false);
} else if (index == "1") {
this.setHomeFloatTop2(false);
} else if (index == "2") {
this.setHomeFloatTop3(false);
} else if (index == "3") {
this.setHomeFloatTop4(false);
} else if (index == "4") {
this.setHomeFloatTop5(false);
}
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/Home/components/home-x-dialog.vue